import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroInvoice'), ...new Mutations('xeroInvoices') };
